module.exports = __webpack_public_path__ + "static/media/dianne.15944764.jpg";